import React, { useState, useMemo } from 'react';
import { useLocation, useHistory } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Message } from 'semantic-ui-react';
import { withRouter } from 'react-router-dom';
import { apiService } from '../../services';
import { Loading } from '../../components/GUI';
import { Page404 } from '../Page404';
import { errorToMessage } from '../../helpers';
import LanguageButton from '../../components/nav/Links/LanguageButton';
import { getLanguage } from '../../helpers/getLocationLanguage';


const BaseSmsOpt = (props) => {
  const { parcel, type, id, error:errMsg, communicationData, showBtn, updateSmsServicesOptAPI, communicationType} = props;
  const location = useLocation();
  const history = useHistory();
  const [done, setDone] = useState(false);
  const [error, setError] = useState(errMsg);
  const [option, setOption] = useState();

  const language = useMemo(() => getLanguage(location), [location]);
  const { t } = useTranslation('sms_opt');
  


  const onSubmit = () => { 
    if(option === 'submit')
    {
      const action = type === 'pid'  ? 'unsubscribe' : 'subscribe'
      const query = `action=${action}&communicationType=${communicationType}`;

      apiService
        .callServer(
          updateSmsServicesOptAPI,
          { ':id:': id, ':type:': type },
          query,
          null,
          null,
          true
        )
        .then(
          _ => {
            setDone(true);
          },
          error => {
            setError(errorToMessage(error));
            setDone(true);
        });
    } else {  // in case of "Ignore"
      setDone(true);
    }
  };

  const renderError = (error) => {
    return (
      <Message
        className='error-message'
        error
        content={error}
      />
    );
  }


  if (error || errMsg) {
    return renderError(error || errMsg);
  }

  let loading = true;
  let parcelFound = false;
  if ((parcel || type === 'bid') && communicationData) {
    parcelFound = true;
    loading = false;
  }

  return (
    <div className="sms-content-wrap">
      <LanguageButton location={location} history={history} language={language} />
    { done ? (
      <div className={`msg ${language}`}>
        {error ? renderError(error) : null}
        {!error && option === 'submit'  && type === 'bid' &&
          <div className="box">
            {t(`subscribeMsg_${communicationType}`)}
          </div>
        }
        {!error && (option === 'submit' && type === 'pid') &&
          <div className="box">
            {t(`unsubscribeMsg_${communicationType}`)}
          </div>
        }
        {!error && (option === 'ignore'  && type === 'pid') &&
          <div className="box">
            {t(`ignoreContinueMsg_${communicationType}`)}
          </div>
        }
        {!error && (option === 'ignore'  && type === 'bid') &&
          <div className="box">
            {t(`ignoreMsg_${communicationType}`)}
          </div>
        }
      </div>
    ) : loading ? (
      <Loading />
    ) : parcelFound ? (
      <div>
        { showBtn ? (
          <div className={`sms-opt-message ${language}`}>
            {t('chooseMsg')}
            <div>
              <div>
                <label className="radio">
                  <input type="radio" value="submit" 
                                checked={option === 'submit'} 
                                onChange={(e) => setOption(e.target.value)} />
                  {props.opt1}
                </label>
              </div>
              <div>
                <label className="radio">
                  <input type="radio" value="ignore" 
                                checked={option === 'ignore'} 
                                onChange={(e) => setOption(e.target.value)} />
                  {props.opt2}
                </label>
              </div>
            </div>
            <div className='button-wrap'>
              {/* <button className={`${props.btnIgnoreClass} btn small orange btn-sms`} onClick={() => onSubmit('subscribe')} disabled={loading}>{props.subscribeText}</button> */}
              <button className='btn small orange btn-sms' onClick={() => onSubmit()} disabled={loading}>{t('send')}</button>
            </div>
          </div>
        ) :  
        ( <div className={`sms-opt-message ${language}`}>
            {props.message}
          {type === 'pid' && 
            <a href='https://www.exelot.com/he/contact' >https://www.exelot.com/he/contact</a>
          }
          </div>
        )
        }
      </div>
    ) : (
      <Page404 />
    )}
    </div>
  );
};

function mapStateToProps(state) {
  const { updateSmsServicesOpt } = state.api;

  return {
    updateSmsServicesOptAPI: updateSmsServicesOpt
  };
}
export default connect(mapStateToProps)(BaseSmsOpt);
